const BASE_URL = process.env.REACT_APP_SHIPENTEGRA_BASE_URL || "https://app.shipentegra.com";
const API_KEY = process.env.REACT_APP_SHIPENTEGRA_API_KEY;
const API_SECRET = process.env.REACT_APP_SHIPENTEGRA_API_SECRET;

let cachedToken = null;
let tokenExpiry = null;

/**
 * ShipEntegra API token al
 */
const getToken = async () => {
  if (cachedToken && tokenExpiry && Date.now() < tokenExpiry) {
    return cachedToken;
  }

  const response = await fetch(`${BASE_URL}/api/v1/auth/token`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ apiKey: API_KEY, apiSecret: API_SECRET }),
  });

  if (!response.ok) {
    throw new Error(`ShipEntegra auth hatası: ${response.status}`);
  }

  const data = await response.json();
  cachedToken = data.token || data.access_token || data.data?.token;
  // Token 1 saat geçerli kabul et
  tokenExpiry = Date.now() + 55 * 60 * 1000;
  return cachedToken;
};

const authHeaders = async () => {
  const token = await getToken();
  return {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };
};

/**
 * Kargo firmalarını listele
 */
export const getCarriers = async () => {
  const headers = await authHeaders();
  const response = await fetch(`${BASE_URL}/api/v1/carrier/list`, { headers });
  if (!response.ok) throw new Error("Kargo firmaları alınamadı");
  const data = await response.json();
  return data.data || data.carriers || data || [];
};

/**
 * Kargo oluştur
 * @param {object} shipmentData - Gönderi bilgileri
 */
export const createShipment = async (shipmentData) => {
  const headers = await authHeaders();
  const response = await fetch(`${BASE_URL}/api/v1/shipment/create`, {
    method: "POST",
    headers,
    body: JSON.stringify(shipmentData),
  });
  if (!response.ok) {
    const errText = await response.text();
    throw new Error(`Kargo oluşturma hatası: ${errText}`);
  }
  const data = await response.json();
  return data.data || data;
};

/**
 * Kargo takip et
 * @param {string} barcode - Kargo takip numarası / barkod
 */
export const trackShipment = async (barcode) => {
  const headers = await authHeaders();
  const response = await fetch(
    `${BASE_URL}/api/v1/shipment/track?barcode=${encodeURIComponent(barcode)}`,
    { headers }
  );
  if (!response.ok) throw new Error("Takip bilgisi alınamadı");
  const data = await response.json();
  return data.data || data;
};

/**
 * Kargo etiketini PDF olarak al
 * @param {string} shipmentId - ShipEntegra gönderi ID
 */
export const getShipmentLabel = async (shipmentId) => {
  const headers = await authHeaders();
  const response = await fetch(
    `${BASE_URL}/api/v1/shipment/label/${shipmentId}`,
    { headers }
  );
  if (!response.ok) throw new Error("Etiket alınamadı");
  const data = await response.json();
  return data.data || data;
};

/**
 * Kargo iptal et
 * @param {string} shipmentId - ShipEntegra gönderi ID
 */
export const cancelShipment = async (shipmentId) => {
  const headers = await authHeaders();
  const response = await fetch(`${BASE_URL}/api/v1/shipment/cancel/${shipmentId}`, {
    method: "POST",
    headers,
  });
  if (!response.ok) throw new Error("İptal işlemi başarısız");
  const data = await response.json();
  return data.data || data;
};
